"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66663 5.83341C1.66663 4.91294 2.41282 4.16675 3.33329 4.16675H16.6666C17.5871 4.16675 18.3333 4.91294 18.3333 5.83341V7.50008C16.9526 7.50008 15.8333 8.61937 15.8333 10.0001C15.8333 11.3808 16.9526 12.5001 18.3333 12.5001V14.1667C18.3333 15.0872 17.5871 15.8334 16.6666 15.8334H3.33329C2.41282 15.8334 1.66663 15.0872 1.66663 14.1667V5.83341ZM8.60967 8.67062C8.52824 8.65879 8.45785 8.60765 8.42143 8.53386L7.72414 7.12099C7.63244 6.93518 7.36748 6.93518 7.27578 7.12099L6.57848 8.53386C6.54207 8.60765 6.47168 8.65879 6.39025 8.67062L4.83106 8.89718C4.62601 8.92698 4.54413 9.17897 4.69251 9.32361L5.82075 10.4234C5.87967 10.4808 5.90656 10.5636 5.89265 10.6447L5.62631 12.1975C5.59128 12.4018 5.80564 12.5575 5.98904 12.4611L7.38362 11.7279C7.45645 11.6896 7.54346 11.6896 7.61629 11.7279L9.01088 12.4611C9.19428 12.5575 9.40864 12.4018 9.37361 12.1975L9.10727 10.6447C9.09336 10.5636 9.12025 10.4808 9.17917 10.4234L10.3074 9.32361C10.4558 9.17897 10.3739 8.92698 10.1689 8.89718L8.60967 8.67062Z",
    fill: fill
  }));
};

exports["default"] = _default;